import apiClient from '../../../api/apiClient';
import { ADMIN_REST_API_BASE_URL } from '../../../config';
const REST_API_BASE_URL = ADMIN_REST_API_BASE_URL;

export const getAllQuestions = () =>
  apiClient.get(REST_API_BASE_URL + '/questions');

export const saveQuestion = (question) =>
  apiClient.post(REST_API_BASE_URL + '/question', question);

export const getQuestion = (id) =>
  apiClient.get(`${REST_API_BASE_URL}/question/${id}`);

export const updateQuestion = (id, question) =>
  apiClient.put(`${REST_API_BASE_URL}/question/${id}`, question);

export const deleteQuestion = (id) =>
  apiClient.delete(`${REST_API_BASE_URL}/question/${id}`);

export const getAllAnswersByQuestion = (subscriptionid, questionid) =>
  apiClient.get(
    `${REST_API_BASE_URL}/subscription/${subscriptionid}/question/${questionid}/answers`,
  );

export const saveAnswer = (subscriptionid, questionid, answer) =>
  apiClient.post(
    `${REST_API_BASE_URL}/subscription/${subscriptionid}/question/${questionid}/answer`,
    answer,
  );

// export const getAnswer = (id) => apiClient.get(`${REST_API_BASE_URL}/answer/${id}`);

// export const updateAnswer = (id, answer) => apiClient.put(`${REST_API_BASE_URL}/answer/${id}`, answer);

export const deleteAnswer = (answerid) =>
  apiClient.delete(`${REST_API_BASE_URL}/answer/${answerid}`);

export default apiClient;
